export const ENERGYJOINUP_CAMPAIGN_PAGE = 'energyjoinup_campaign_page';
